// ログイン時にtoken refreshが失敗してローディングが終わらない場合の処理に使用する
export const SS_RETRY_RELOAD_COUNT = 'ss_retry_reload_count';
export const SS_AUTH_VALIDATION_RETRY_COUNT = 'ss_auth_validation_retry_count';
